module.exports = __webpack_public_path__ + "static/media/hra2.5782a7a8.webp";